import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  IconStyled,
  OrderInfoContainer,
  ValueContainer,
  ValueStyled,
} from './TrlOrderInfo.styles';

export const TrlOrderInfo = ({ label, icon, value }) => (
  <OrderInfoContainer>
    <FormattedMessage id={label} />
    <ValueContainer>
      <IconStyled icon={icon} />
      <ValueStyled>{value}</ValueStyled>
    </ValueContainer>
  </OrderInfoContainer>
);

TrlOrderInfo.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
